<template>
  <CHeader with-subheader>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <!-- <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon name="logo" height="48" alt="Logo" />
    </CHeaderBrand> -->
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <!-- <CHeaderNavLink style="color: black; font-size: 20px"
          >{{ this.user.firstName + " " + this.user.lastName }}
        </CHeaderNavLink> -->
      </CHeaderNavItem>
      <!-- <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/users" exact>Users</CHeaderNavLink>
      </CHeaderNavItem>-->
      <CHeaderNavItem class="px-3">
        <b> Email : {{ this.user.email }} </b> &nbsp;,
        <b>Role : {{ this.user.userRole }} </b>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav>
      <CHeaderNavItem class="px-3"> </CHeaderNavItem>
      <TheHeaderDropdownNotif />
      <!-- <TheHeaderDropdownTasks /> -->
      <!-- <TheHeaderDropdownMssgs /> -->
      <CHeaderNavItem class="px-3">
        <i
          class="fa fa-sign-out"
          aria-hidden="true"
          @click="deleteRoute()"
          style="font-size: x-large"
        ></i>
      </CHeaderNavItem>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0" />
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import TheHeaderDropdownNotif from "./TheHeaderDropdownNotif";
import TheHeaderDropdownTasks from "./TheHeaderDropdownTasks";
import TheHeaderDropdownMssgs from "./TheHeaderDropdownMssgs";
import firebase from "firebase";
import loader from "vue-ui-preloader";
import Swal from "sweetalert2";
export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif,
    TheHeaderDropdownTasks,
    TheHeaderDropdownMssgs,
    loader,
  },
  methods: {
    deleteRoute() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          // text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, Logout!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire("success");
            this.logOut();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              // "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    logOut() {
      const auth = firebase.auth();
      auth
        .signOut()
        .then(() => {
          localStorage.clear();
          this.$router.push({ name: "LoginPage" });
          location.reload();
        })
        .catch(function (error) {
          // An error happened
          alert("Error Occured");
        });
    },
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("data")); //push all data to this.articles
  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
</style>

